export default {
    defaultPath: '/', basename: '/', // only at build time to set, like ///able-pro/react/default
    layout: 'vertical', // vertical, horizontal
    subLayout: '', // horizontal-2
    collapseMenu: false, // mini-menu
    layoutType: 'menu-dark', // menu-dark, menu-light, dark
    headerBackColor: 'background-grd-blue', // header-blue, background-blue, background-red, background-purple, background-info, background-green, background-dark, background-grd-blue, background-grd-red, background-grd-purple, background-grd-info, background-grd-green, background-grd-dark, background-img-1, background-img-2, background-img-3, background-img-4, background-img-5, background-img-6
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: false,
    boxLayout: false,
    entity: 1, //1: Posgrado | 2: SeFcs
    entityName: 'ESCUELA DE POSGRADO', //1: ESCUELA DE POSGRADO | 2: SEGUNDA ESPECIALIDAD FCS
    mode: 'PRO'
};

//set NODE_OPTIONS=--max_old_space_size=12096
// export NODE_OPTIONS="--max-old-space-size=10240"
// $env:NODE_OPTIONS="--max-old-space-size=10240"
// npm run build



